import React, { useState } from 'react';


import './Login.css';

import axios from 'axios';


import Footer from '../../../components/footer/Footer';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const LoginForm = () => {
  const [fields, setFields] = useState({
    email: '',
    password: ''
  });

  const [errors, setErrors] = useState({});
  const themeMode = localStorage.getItem('themeMode') || 'light';

  const handleChange = (e) => {
    setFields((prevFields) => ({
      ...prevFields,
      [e.target.name]: e.target.value
    }));
  };

  const submitLoginForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      axios
        .post(`${API_BASE_URL}/newuser/login`, fields)
        .then((response) => {
          const isAdmin = response.data.isAdmin;
          localStorage.setItem('userData', JSON.stringify(response.data));

          setFields({
            email: '',
            password: ''
          });
          if (isAdmin === true) {
            window.location.href = '/admin/auth/AdminDashboard';
          } else {
            window.location.href = '/';
          }
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            // Display error message from the server response
            setErrors({ login: error.response.data.message });
          } else {
            console.error(error);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.email) {
      formIsValid = false;
      errors.email = '*Please enter your email.';
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        fields.email
      )
    ) {
      formIsValid = false;
      errors.email = '*Please enter a valid email.';
    }

    setErrors(errors);
    return formIsValid;
  };

  

  
  
  return (
    <>
    <div className={`login-container ${themeMode}`}>
     
      <div className={`Login-wrapper ${themeMode}`}>
        

        <div className={`main-registration-container`}>
          
          <h3 className={`desc-theme ${themeMode}`}>Administrator Login</h3>
         
          <div className={`register ${themeMode}`}>
            <h2 className={`signup-text ${themeMode}`}>Login</h2>
            {errors.email && <div className="errorMsg">{errors.email}</div>}
            <form method="post" name="userLoginForm" onSubmit={submitLoginForm}>
              <label className={`label ${themeMode}`}>Email:</label>
              <input
                type="text"
                name="email"
                value={fields.email}
                onChange={handleChange}
              />
             
              <label className={`label ${themeMode}`}>Password</label>
              <input
                type="password"
                name="password"
                value={fields.password}
                onChange={handleChange}
              />
              {errors.login && <div className="errorMsg">{errors.login}</div>}
              <input type="submit" className={`button`} value="Login" />
            </form>
            <span className='signup-text-container'>
             
            </span>
          </div>
         
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default LoginForm;
